import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles, THEME_VARIANTS } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    padding: theme.spacing(6, 8),
    borderRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  coverages: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6)
  },
  toggle: {
    marginLeft: theme.spacing(1)
  },
  subSection: {
    borderTop: `1px solid ${theme.onCardDivider.beige_25_op_30}`,
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(4)
  },
  subSectionTitle: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.colorPalette.beige_60
  },
  subSectionCollapsible: {
    marginTop: theme.spacing(2)
  },
  umStateNotice: {
    display: 'flex',
    alignItems: 'center',
    height: 78
  },
  fieldWithTooltip: {
    position: 'relative',
    '& > div': {
      height: 'auto'
    }
  },
  fieldTooltip: {
    position: 'absolute',
    right: theme.spacing(2),
    top: 0
  },
  subSectionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  totalLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  totalText: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.beige_60
  },
  totalCount: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.onCard.beige_25
  },
  requirementsNotification: {
    padding: theme.spacing(0, 2, 2),
    marginTop: -12
  },
  requirementsIcon: {
    alignSelf: 'flex-start'
  },
  requirementsContent: {
    paddingLeft: theme.spacing(2)
  },
  requirementsText: {
    display: 'block',
    fontSize: 12,
    lineHeight: '16px',
    '& strong': {
      fontWeight: 600
    }
  },
  requirementsHeading: {
    display: 'block',
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600,
    marginTop: theme.spacing(4)
  },
  requirementsList: {
    margin: 0,
    padding: theme.spacing(0, 0, 0, 2),
    fontSize: 12,
    lineHeight: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  requirementRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2)
  },
  requirementRowIcon: {
    width: 16,
    height: 16,
    flexShrink: 0
  },
  estimateAction: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  requirementApplyButton: {
    color: theme.themeVariant === THEME_VARIANTS.RESKIN ? theme.colors.action_text : theme.onCard.orange_on_dark,
    height: 16,
    padding: theme.spacing(0, 1),
    minWidth: 0,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
    flexShrink: 0
  }
});

export default makeStyles(styles);
